import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';
import { CommunitiesProps, CommunitiesRequest } from './communities.interface';
import { authHeader } from '../../../../../utils/common/authHeader';

export const adminCommunitiesApi = createApi({
    reducerPath: 'adminCommunitiesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL + '/manager',
        prepareHeaders: (headers: Headers) => authHeader(headers),
    }),
    endpoints: build => ({
        readCommunities: build.query<
            PaginatedResponse<CommunitiesProps>,
            CommunitiesRequest
        >({
            query: payload => {
                const queryArgs = qs.stringify(payload.filters, {
                    arrayFormat: 'bracket-separator',
                    skipNull: true,
                });
                return {
                    url: `communities?${queryArgs}`,
                };
            },
            transformResponse: (res: { data: CommunitiesProps[] }, meta) => {
                return {
                    items: res.data || [],
                    total:
                        Number(meta.response.headers.get('items-count')) || 0,
                };
            },
        }),
    }),
});

export const { useLazyReadCommunitiesQuery } = adminCommunitiesApi;
